import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = {};

const updateAll = (state, { payload }) => ({
  ...state,
  ...payload.fields,
});

export default createReducer(initialState, {
  [actionTypes.FETCH_FIELDS_SUCCESS]: updateAll,
});
